import TextBox from 'devextreme-react/text-box';
import React, { useEffect, useState } from 'react';
import { Modal } from 'semantic-ui-react';
import { phuHuynhApi } from '../../api/phuHuynhApi';
import { showNotify } from '../../helpers/toast';
import { DefaultButton, PrimaryButton } from '../editor/button';
import { FormGroup } from '../form-group';

const PhuHuynhEditModal = ({
    onCancel,
    phuHuynhId,
    onSuccess
}) => {
    const [formData, setFormData] = useState();
    const [isSaving, setIsSaving] = useState();
    useEffect(() => {
        handleGetInfo();
    }, [phuHuynhId])
    const handleGetInfo = async () => {
        const res = await phuHuynhApi.Detail(phuHuynhId);
        if (res.is_success) {
            setFormData(res.data);
        }
    }
    const handleSaveChanges = async () => {
        let res;
        if (phuHuynhId > 0) {
            setIsSaving(true);
            res = await phuHuynhApi.UpdateInfo(formData);
            if (res.is_success) {
                setIsSaving(false);
                showNotify({ type: "success", text: "Cập nhật thành công" });
                onSuccess();
            }else{
                setIsSaving(false);
                showNotify({ type: "error", text: "Cập nhật thất bại" });
            }
        }
    }
    return (
        <div>
            <Modal
                open={true}
                size="mini"
                // dimmer={"blurring"}
                onClose={onCancel}
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header>
                    {phuHuynhId > 0 ? (
                        <p>{'Cập nhật'}</p>
                    ) : (
                        <p>{'Thêm mới'}</p>
                    )}
                </Modal.Header>
                <Modal.Content>
                    <form className="ui">
                        <input className="hide" name="id" defaultValue={phuHuynhId}></input>
                        <FormGroup label={"Họ tên"}>
                            <TextBox
                                value={formData?.ho_ten}
                                stylingMode="outlined"
                                onValueChanged={(e) => {
                                    if (e.event) setFormData({ ...formData, ho_ten: e.value })
                                }}
                            />
                        </FormGroup>
                        <FormGroup label={"Điện thoại"}>
                            <TextBox
                                value={formData?.dien_thoai}
                                stylingMode="outlined"
                                onValueChanged={(e) => {
                                    if (e.event) setFormData({ ...formData, dien_thoai: e.value })
                                }}
                            />
                        </FormGroup>
                        <FormGroup label={"Email"}>
                            <TextBox
                                value={formData?.email}
                                stylingMode="outlined"
                                onValueChanged={(e) => {
                                    if (e.event) setFormData({ ...formData, email: e.value })
                                }}
                            />
                        </FormGroup>
                        <FormGroup label={"Địa chỉ"}>
                            <TextBox
                                value={formData?.dia_chi_thuong_tru}
                                stylingMode="outlined"
                                onValueChanged={(e) => {
                                    if (e.event) setFormData({ ...formData, dia_chi_thuong_tru: e.value })
                                }}
                            />
                        </FormGroup>
                    </form>
                </Modal.Content>
                <Modal.Actions>
                    <div>
                        <DefaultButton text="Đóng" onClick={onCancel} />
                        <PrimaryButton text={phuHuynhId > 0 ? "Cập nhật" : "Đóng"}
                            onClick={handleSaveChanges}
                            isLoading={isSaving}
                        />
                    </div>
                </Modal.Actions>
            </Modal>
        </div>
    );
};

export default PhuHuynhEditModal;